export default "__VITE_ASSET__BFMOL1Kt__"